import React from 'react';
import { useApiLoadingPool, usePreventInfiniteLoading, useScrollToTop } from '@/util/hook/custom';
import useMemo from '@/util/hook/useMemo';
import useSelector from '@/util/hook/useSelector';
import { useGetCareClientVisitorProfile } from '../../util/hook/useGetCareClientVisitorProfile';
import { useGetRemoteConfig } from '../../util/hook/useGetRemoteConfig';
import { useTrackBrowserHistory } from '../../util/hook/useTrackBrowserHistory';
import { useValidateCareClientVisitorProfileAndRedirect } from '../../util/hook/useValidateCareClientVisitorProfileAndRedirect';
import { selectCareOrderBaby } from '../../redux/module/careOrderBaby';
import View from './View';
import { CareOrderBabyUConverter } from '../../util/uiConverter/CareOrderBaby';
export default function Controller() {
    const { isLoading, setApiProcessingPool, setApiDonePool } = useApiLoadingPool(true);
    const careOrderBaby = useSelector(selectCareOrderBaby);
    useTrackBrowserHistory();
    useGetRemoteConfig({ setApiProcessingPool, setApiDonePool });
    useGetCareClientVisitorProfile({ setApiProcessingPool, setApiDonePool });
    useValidateCareClientVisitorProfileAndRedirect({ redirectRoute: null });
    useScrollToTop();
    usePreventInfiniteLoading({ setApiProcessingPool, setApiDonePool });
    const careOrderBabyForTransferInstructionPage = useMemo(() => {
        const data = CareOrderBabyUConverter.getDataForTransferInstructionPage({
            careOrderBaby,
        });
        return data;
    }, [careOrderBaby]);
    return (<View 
    // data
    isLoading={isLoading} careOrderBabyForTransferInstructionPage={careOrderBabyForTransferInstructionPage}/>);
}
